/**
 * /api/workspaces/me/budget — workspace resource budget (Phase 12 / M10).
 *
 * Read access is open to any workspace member; only founder/admin can
 * mutate. The Settings → Workspace page surfaces both endpoints via
 * useResourceBudget + useUpdateResourceBudget.
 */
import type { ResourceBudget, UpdateResourceBudgetInput } from '@chaos/types/system';

import { apiJson } from './client';

export const workspaceApi = {
  getBudget(): Promise<ResourceBudget> {
    return apiJson<{ budget: ResourceBudget }>('/workspaces/me/budget').then((r) => r.budget);
  },
  updateBudget(input: UpdateResourceBudgetInput): Promise<ResourceBudget> {
    return apiJson<{ budget: ResourceBudget }>('/workspaces/me/budget', {
      method: 'PATCH',
      json: input,
    }).then((r) => r.budget);
  },
};

export const workspaceKeys = {
  all: ['workspace'] as const,
  budget: () => [...workspaceKeys.all, 'budget'] as const,
};
